module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Ka-Ld.d118e062.png";